import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Form, Button } from 'react-bootstrap';

import Price from 'components/Price';
import { ReactComponent as Info } from 'assets/images/icons/Info.svg';

export const CarPartCard = ({ engineData, bodyData, onSelect, onDetails, buttonText }) => {
    const { t } = useTranslation();
    const { body, specification } = useSelector(state => state.config);

    const data = engineData || bodyData || {};
    const eic = data.eic;
    const id = data.id;
    const title = data.title;
    const price = data.leasing?.period?.[0]?.mileage?.[0]?.price || 0;
    const info = data.style;
    const doors = data.doors;
    const seats = data.seats;
    const img = data.thumb || data.img

    const badge = ['hybrid', 'electric'].filter(item => data.type?.toLowerCase().includes(item))[0];
    const isActive = React.useMemo(() => eic ? eic === specification : id === body, [body, specification, data]);

    const handleSelect = () => {
        const firstEngine = data.engines?.[0];
        const engineEic = firstEngine?.eic || null;
        const engineId = engineEic && engineEic !== specification ? firstEngine.id : null;
        eic ? onSelect(id, eic) : onSelect(id, engineId, engineEic);
    };

    const buttonProps = {
        type: 'radio',
        onChange: handleSelect,
        checked: isActive,
    };

    const techdata = (data.techdata || []).filter(item => ['ENGINETYPE', 'RANGE', 'CONSELECTRIC', 'MAXPOWERKW'].includes(item.code));

    return (
        <Form.Label className={`c-engine ${isActive ? 'active' : ''}`}>
            <div className="c-engine__img">
                <img src={img} />
            </div>
            <div className="c-engine__head">
                <h3 className="c-engine__title">{title}</h3>
            </div>
            <div className="c-engine__body">
                {price && (
                    <p className="c-engine__price">
                        <strong className="c-price c-price--new">
                            <span className="c-price__title">
                                {t('monthly_price')} <Price price={price} />
                            </span>
                        </strong>
                    </p>
                )}
                {info && (
                    <p className="c-engine__descr">{info}</p>
                )}
                <ul className="c-engine__tech c-info__list">
                    {techdata.map(item => (
                        <li className="c-info__item" key={item.code}>{`${item.name} - ${item.value}`}</li>
                    ))}
                </ul>
                <p className="c-engine__btnline">
                    <Button as="a" variant="link" onClick={onDetails}>
                        <Info className="btn-ico btn-ico-left" />
                        {t('additional_info')}
                    </Button>
                </p>
            </div>
            <div className="c-engine__footer">
                <Form.Check className="c-engine__check">
                    <Form.Check.Input {...buttonProps} />
                    <span className="form-check-label">{t(buttonText)}</span>
                </Form.Check>
            </div>
        </Form.Label>
    );
};
